export default __webpack_public_path__ + "static/media/Papers.5054af13.gif";